const definePermissions = (user, PermPermissionStore) => {
  PermPermissionStore.defineManyPermissions(user.permissions, () => true);
};

const getRoleDefinitions = (user = {}) => {
  const employerRoles = ["MANAGER", "CLIENT", "CLIENT_ADMIN"];
  const internalRoles = ["BRANCH_OPS", "BRANCH_VIS", "ADMIN", "PAYROLL_ADMIN", "SUPER_ADMIN"];

  return {
    BLUECREW: () => user.accountType === "BLUECREW",
    MANAGER: () => user.accountType === "MANAGER",
    CLIENT: () => user.accountType === "CLIENT",
    CLIENT_ADMIN: () => user.accountType === "CLIENT_ADMIN",
    BRANCH_OPS: () => user.accountType === "BRANCH_OPS",
    BRANCH_VIS: () => user.accountType === "BRANCH_VIS",
    ADMIN: () =>
      user.accountType === "ADMIN" ||
      user.accountType === "PAYROLL_ADMIN" ||
      user.accountType === "SUPER_ADMIN",
    PAYROLL_ADMIN: () =>
      user.accountType === "PAYROLL_ADMIN" ||
      user.accountType === "SUPER_ADMIN",
    EMPLOYER: () =>
      employerRoles.includes(user.accountType) &&
      user.companyName &&
      user.canPostJobs,
    INTERNAL: () => internalRoles.includes(user.accountType),
  };
};


export default {
  definePermissions,
  getRoleDefinitions,
};
